import { createContext, useContext, useMemo, useState } from "react";
import { translations } from "@/i18n/translations";

const LangContext = createContext({ lang: "it", setLang: () => {}, t: translations.it });

export function LangProvider({ children }) {
  const [lang, setLang] = useState("it");
  const value = useMemo(() => ({ lang, setLang, t: translations[lang] }), [lang]);
  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
}

export const useLang = () => useContext(LangContext);
